import React from 'react'
import BEMHelper from 'react-bem-helper'

import { Grid, Col } from '../../components/Grid'
import Contact from '../../components/Contact'
import List from '../../components/List'
import Preview from '../../components/Preview'

import ncl_logo from '../../images/cases/ncl-logo.jpg'
import ncl_video from '../../images/cases/ncl_containers.mp4'
import ncl_mob_img0 from '../../images/cases/ncl_mobile_frontpage.png'
import ncl_mob_img1 from '../../images/cases/ncl_vessels-mobile.png'
import ncl_mob_img2 from '../../images/cases/ncl_schedule-table-mobile.png'

import './index.css'
import cases from '../../data/cases'
import Helmet from '../../components/seo/Helmet'

const classes = new BEMHelper('ncl')

export default function NCL ({ helmetProps }) {
  const info = cases.find(({ slug }) => slug === 'ncl')
  const { name } = info

  const images = [
    { src: ncl_mob_img0, caption: 'NCL mobile frontpage' },
    { src: ncl_mob_img1, caption: 'NCL mobile map page' },
    { src: ncl_mob_img2, caption: 'NCL mobile calendar page' }
  ]
  return (
    <article {...classes('')}>
      <Helmet {...helmetProps} />
      <h1 {...classes('title')}>{name}</h1>

      <Grid>
        <Col>
          <img src={ncl_logo} alt="NCL Logo" {...classes('logo')} />
          <video {...classes('video')} autoPlay loop alt="Video av lossing" playsinline src={ncl_video} />
        </Col>

        <Col>
          <p>
            I samarbeid med Behalf har
            vi laget de nye nettsidene til rederiet North Sea Container Line (NCL).
            Sidene har fått bestillingsløsning og prisforespørsel innebygget,
            og man kan følge skipenes ferd på havet.
          </p>

          <p>
            Appresso sitt ansvar i prosjektet er arkitektur, implementasjon og drift av backend.
            Backend er laget med Python, Django og Postgres som hovedkomponenter, og den kjører som
            et <em>headless CMS</em>. Back-end driftes på Appressos Enterprise Cloud hos Heroku.
            Backend er ved hjelp av API-er integert mot NCLs backoffice løsning.
          </p>

          <p>
            Front-end er laget av Behalf, den er implementert med React og GatsbyJS,
            og hostes på Netlify.
          </p>

          <List>
            <li>
              <a
                href="https://www.behalf.no/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Behalf
              </a>
            </li>
            <li>
              <a
                href="https://www.ncl.no"
                target="_blank"
                rel="noopener noreferrer"
              >
                NCL.no
              </a>
            </li>
            <li>
              <a
                href="https://www.heroku.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Heroku
              </a>
            </li>
            <li>
              <a
                href="https://www.netlify.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Netlify
              </a>
            </li>
          </List>
        </Col>
      </Grid>

      <Preview slides={images} />

      <Contact
        who="tor"
        title="Vil du ta en prat om det vi har gjort for NCL?"
      >
        Ta kontakt med <strong>Tor Ivar</strong> om du lurer mer på hva vi har
        gjort for NCL.
      </Contact>
    </article>
  )
}



// WEBPACK FOOTER //
// ./src/pages/NCL/index.js